(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_pdp_value_messaging_2026"] && !Shopify.designMode) return;
  try {
    // Tooltip behavior intentionally disabled for now.
  } catch(e) { console.error(e); }
})();

})();
